import { render, staticRenderFns } from "./indexAccounts.vue?vue&type=template&id=4aa6e1f8&"
import script from "./indexAccounts.vue?vue&type=script&lang=ts&"
export * from "./indexAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports